import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { toast } from 'sonner';
import api from '@/lib/api';
import { fmtIST } from './recoveryUi';

export default function RedFlagCards({ planId, alerts, onChanged }) {
  const follow = async (id, resolved) => {
    try {
      await api.post(`/patient/recovery/${planId}/redflag/${id}/followup`, { resolved });
      toast[resolved ? 'success' : 'error'](resolved ? 'Glad you feel better' : 'Your surgical team has been alerted');
      onChanged();
    } catch { toast.error('Could not update'); }
  };
  return alerts.filter((a) => a.stage === 'self_care').map((a) => (
    <section key={a.id} className="rounded-2xl border-2 border-amber-400 bg-amber-50 p-4" data-testid={`recovery-selfcare-${a.id}`}>
      <div className="flex items-start gap-2 text-amber-900">
        <AlertTriangle size={18} className="shrink-0 mt-0.5" />
        <div>
          <div className="text-[14px] font-extrabold">{a.title}</div>
          <div className="text-[12px] mt-0.5">Do this now. We will check again by <b>{fmtIST(a.deadline_at)}</b>.</div>
        </div>
      </div>
      <ul className="mt-2 list-disc pl-6 text-[14px] text-amber-950 space-y-1">{(a.self_care || []).map((s) => <li key={s}>{s}</li>)}</ul>
      <div className="mt-3 grid grid-cols-2 gap-2">
        <button type="button" onClick={() => follow(a.id, true)} className="py-2.5 rounded-xl bg-emerald-600 text-white text-[13px] font-bold" data-testid={`recovery-selfcare-better-${a.id}`}>I feel better</button>
        <button type="button" onClick={() => follow(a.id, false)} className="py-2.5 rounded-xl bg-red-700 text-white text-[13px] font-bold" data-testid={`recovery-selfcare-still-${a.id}`}>Still there</button>
      </div>
    </section>
  ));
}
